/* ============================================================
   BB BY LYRAH — Audio Player
   Floating button · Play/Pause · localStorage persistence
   ============================================================ */

(function () {
  'use strict';

  var STORAGE_KEY = 'bb_music_state';
  var TARGET_VOLUME = 0.18;

  var btn   = null;
  var audio = null;
  var isPlaying = false;

  function init() {
    btn = document.getElementById('bb-audio-btn');
    if (!btn) return;

    var src = btn.dataset.src;
    if (!src) return;

    audio = new Audio(src);
    audio.loop         = true;
    audio.volume       = 0;
    audio.preload      = 'auto';

    btn.addEventListener('click', handleClick);

    audio.addEventListener('play',  function () { setPlaying(true);  });
    audio.addEventListener('pause', function () { setPlaying(false); });
    audio.addEventListener('ended', function () { setPlaying(false); });

    /* Restore state: if user had music on, try to resume */
    var saved = readStorage();
    if (saved === 'on') {
      /* Attempt silent autoplay — browsers may allow it if user previously interacted */
      audio.volume = 0;
      var p = audio.play();
      if (p !== undefined) {
        p.then(function () {
          fadeIn();
        }).catch(function () {
          /* Autoplay blocked — button stays in "off" state, user taps to start */
          setPlaying(false);
        });
      }
    } else {
      setPlaying(false);
    }
  }

  function handleClick() {
    if (isPlaying) {
      fadeOut(function () { audio.pause(); });
      writeStorage('off');
    } else {
      audio.volume = TARGET_VOLUME;
      var p = audio.play();
      if (p !== undefined) {
        p.catch(function () {});
      }
      setPlaying(true);
      writeStorage('on');
    }
  }

  function setPlaying(state) {
    isPlaying = state;
    btn.setAttribute('aria-pressed', state ? 'true' : 'false');
    btn.setAttribute('aria-label', state ? 'Couper la musique' : 'Activer la musique');

    var iconOff = btn.querySelector('.bb-audio-icon--off');
    var iconOn  = btn.querySelector('.bb-audio-icon--on');

    if (iconOff) iconOff.style.display = state ? 'none' : 'block';
    if (iconOn)  iconOn.style.display  = state ? 'block' : 'none';

    if (state) {
      btn.classList.add('is-playing');
    } else {
      btn.classList.remove('is-playing');
    }
  }

  function fadeIn(duration) {
    duration = duration || 1000;
    setPlaying(true);
    var steps = duration / 30;
    var increment = TARGET_VOLUME / steps;
    var interval = setInterval(function () {
      if (audio.volume < TARGET_VOLUME - increment) {
        audio.volume = Math.min(TARGET_VOLUME, audio.volume + increment);
      } else {
        audio.volume = TARGET_VOLUME;
        clearInterval(interval);
      }
    }, 30);
  }

  function fadeOut(callback, duration) {
    duration = duration || 600;
    var start = audio.volume;
    var steps = duration / 30;
    var decrement = start / steps;
    var interval = setInterval(function () {
      if (audio.volume > decrement) {
        audio.volume = Math.max(0, audio.volume - decrement);
      } else {
        audio.volume = 0;
        clearInterval(interval);
        setPlaying(false);
        if (typeof callback === 'function') callback();
      }
    }, 30);
  }

  function readStorage() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function writeStorage(value) {
    try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.BBAudio = { play: function () { if (audio) audio.play(); }, pause: function () { if (audio) audio.pause(); } };
})();
